module.exports = __webpack_public_path__ + "img/facts.dcec6e.png";